import React from 'react';
import GoBeApp from '../../SubApp/gb_operator_module/src/App';
import isAuthenticated from '../Authentication/Authenticated';

const GoBe = () => {
	return <GoBeApp />;
};

export default isAuthenticated(GoBe, 'GoBe');
